// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__dl-wA","Label":"Input_Label__18mPK","InputElement":"Input_InputElement__3BwO3","Invalid":"Input_Invalid__29KpY"};